import React, { useEffect } from "react";
import { Avatar } from "@mui/material";
import {
    PATH_PATTERNS,
    buildPathFromPattern,
    pathMatchesPattern as matchPattern,
    pathMatchesAnyPattern,
} from "../../../helper/url-builder";

import SearchIcon from '@mui/icons-material/ManageSearch';
import AboutIcon from "../../../assets/svg-icon-for-menu/about-icon.svg";
import ManageCompanyIcon from "../../../assets/svg-icon-for-menu/managed-companies-icon.svg";
import TeamMembersIcon from "../../../assets/svg-icon-for-menu/team-members-icon.svg";
import AlertsIcon from "../../../assets/svg-icon-for-menu/alerts-icon.svg";
import ActivityLogIcon from "../../../assets/svg-icon-for-menu/activity-log-icon.svg";
import SystemSettingIcon from "../../../assets/svg-icon-for-menu/system-settings-icon.svg";
import TerritoriesIcon from "../../../assets/svg-icon-for-menu/territories-icon.svg";
import StatutoryHolidaysIcon from "../../../assets/svg-icon-for-menu/statutory-holidays-icon.svg";
import TimeOfUsePlansIcon from "../../../assets/svg-icon-for-menu/time-of-use-plans-icon.svg";
import SaleTaxPlansIcon from "../../../assets/svg-icon-for-menu/sales-tax-plans-icon.svg";
import InstallationIcon from "../../../assets/svg-icon-for-menu/installation-icon.svg";
import InvoiceIcon from "../../../assets/svg-icon-for-menu/invoice-icon.svg";
import TransactionIcon from "../../../assets/svg-icon-for-menu/transaction-icon.svg";
import ProjectManagementIcon from "../../../assets/svg-icon-for-menu/project-management-icon.svg";
import BillingSettingsIcon from "../../../assets/svg-icon-for-menu/billing-icon-settings.svg";
import ControllersIcon from "../../../assets/svg-icon-for-menu/controllers-icon.svg";
import ChargingPointsIcons from "../../../assets/svg-icon-for-menu/charge-points-icon.svg";
import LicencesIcon from "../../../assets/svg-icon-for-menu/licences-icon.svg";
import DriversIcon from "../../../assets/svg-icon-for-menu/drivers-icon.svg";

import AboutWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/about-white-icon.svg";
import ManagedCompanyWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/managed-company-white-icon.svg";
import TeamMemberWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/team-member-white-icon.svg";
import AlertsWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/alerts-white-icon.svg";
import ActivityLogWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/activity-log-white-icon.svg";
import SystemSettingWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/system-setting-white-icon.svg";
import TerritoriesWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/territories-white-icon.svg";
import StatutoryHolidaysWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/statutory-holidays-white-icon.svg";
import TimeOfUsePlansWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/time-of-use-plans-white-icon.svg";
import SalesTaxPlanWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/sales-tax-plans-white-icon.svg";
import InstallationWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/installation-white-icon.svg";
import DriversWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/drivers-white-icon.svg";
import InvoiceWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/invoice-white-icon.svg";
import TransactionWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/transaction-white-icon.svg";
import BillingSettingWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/billing-setting-white-icon.svg";
import ControllerWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/controller-white-icon.svg";
import ChargepointWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/charge-points-white-icon.svg";
import LicencesWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/licences-white-icon.svg";
import ProjectManagementWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/project-management-white-icon.svg";
import ChargingStatusIcon from "../../../assets/svg-icon-for-menu/charging-status-icon.svg";
import ChargingStatusWhiteIcon from "../../../assets/svg-icon-for-menu/white-icon/charging-status-white-icon.svg";
import SiteLoadIcon from "@mui/icons-material/ShowChart";

// Re-export utilities for use by menu components
export const buildPath = buildPathFromPattern;
export const pathMatchesPattern = matchPattern;
export const pathMatchesAny = pathMatchesAnyPattern;

// PATH_LIST maps legacy keys to PATH_PATTERNS for backward compatibility
export const PATH_LIST = {
    ABOUT_COMPANIES: PATH_PATTERNS.ABOUT,
    MANAGED_COMPANIES: PATH_PATTERNS.MANAGED_COMPANIES,
    TEAM_MEMBERS: PATH_PATTERNS.TEAM_MEMBERS,
    ALERTS: PATH_PATTERNS.ALERTS,
    ACTIVITY_LOG: PATH_PATTERNS.ACTIVITY_LOG,
    SEARCH: PATH_PATTERNS.SEARCH,
    SYSTEM_SETTING_TERRITORIES: PATH_PATTERNS.SYSTEM_SETTING_TERRITORIES,
    SYSTEM_SETTING_HOLIDAY: PATH_PATTERNS.SYSTEM_SETTING_HOLIDAYS,
    SYSTEM_SETTING_TIME_OF_USE_PLANS: PATH_PATTERNS.SYSTEM_SETTING_TIME_OF_USE,
    SYSTEM_SETTING_SALES_TAB_PLANS: PATH_PATTERNS.SYSTEM_SETTING_SALES_TAX,
    INSTALLATION: PATH_PATTERNS.NEW_INSTALLATION,
    INSTALLATION_GENERAL_INFO: PATH_PATTERNS.INSTALLATION_SETTINGS,
    INSTALLATION_CHARGEPOINT_STATUS: PATH_PATTERNS.INSTALLATION_CHARGEPOINT_STATUS,
    INSTALLATION_SITE_LOAD: PATH_PATTERNS.INSTALLATION_SITE_LOAD,
    INSTALLATION_DRIVER: PATH_PATTERNS.INSTALLATION_DRIVERS,
    INSTALLATION_DRIVER_DETAIL: PATH_PATTERNS.INSTALLATION_DRIVER_DETAIL,
    INSTALLATION_DRIVER_CHARGEPOINTS: PATH_PATTERNS.INSTALLATION_DRIVER_CHARGEPOINTS,
    INSTALLATION_INVOICE: PATH_PATTERNS.INSTALLATION_INVOICES,
    INSTALLATION_TRANSACTIONS: PATH_PATTERNS.INSTALLATION_TRANSACTIONS,
    INSTALLATION_BILLING_SETTINGS: PATH_PATTERNS.INSTALLATION_BILLING_SETTINGS,
    INSTALLATION_CONTROLLERS: PATH_PATTERNS.INSTALLATION_CONTROLLERS,
    INSTALLATION_CONTROLLER_DETAIL: PATH_PATTERNS.INSTALLATION_CONTROLLER_DETAIL,
    INSTALLATION_CONTROLLER_SENSING: PATH_PATTERNS.INSTALLATION_CONTROLLER_SENSING,
    INSTALLATION_CONTROLLER_TOPOLOGY: PATH_PATTERNS.INSTALLATION_CONTROLLER_TOPOLOGY,
    INSTALLATION_CHARGE_POINTS: PATH_PATTERNS.INSTALLATION_CHARGEPOINTS,
    INSTALLATION_LICENCES: PATH_PATTERNS.INSTALLATION_LICENCES,
    INSTALLATION_PROJECT_MANAGEMENT: PATH_PATTERNS.INSTALLATION_PROJECT_MANAGEMENT,
};

export const MENU_ID_LIST = {
    "about": [PATH_LIST.ABOUT_COMPANIES],
    "managed companies": [PATH_LIST.MANAGED_COMPANIES],
    "Team members": [PATH_LIST.TEAM_MEMBERS],
    "alerts": [PATH_LIST.ALERTS],
    "Activity log": [PATH_LIST.ACTIVITY_LOG],
    "Search": [PATH_LIST.SEARCH],
    "System Settings": [PATH_LIST.SYSTEM_SETTING_TERRITORIES, PATH_LIST.SYSTEM_SETTING_HOLIDAY, PATH_LIST.SYSTEM_SETTING_TIME_OF_USE_PLANS, PATH_LIST.SYSTEM_SETTING_SALES_TAB_PLANS],
    "Statutory holidays": [PATH_LIST.SYSTEM_SETTING_HOLIDAY],
    "Territories": [PATH_LIST.SYSTEM_SETTING_TERRITORIES],
    "Time-of-use plans": [PATH_LIST.SYSTEM_SETTING_TIME_OF_USE_PLANS],
    "Sales tax plans": [PATH_LIST.SYSTEM_SETTING_SALES_TAB_PLANS],
    "Installation": [PATH_LIST.INSTALLATION, PATH_LIST.INSTALLATION_GENERAL_INFO, PATH_LIST.INSTALLATION_CHARGEPOINT_STATUS, PATH_LIST.INSTALLATION_SITE_LOAD, PATH_LIST.INSTALLATION_INVOICE,PATH_LIST.INSTALLATION_TRANSACTIONS, PATH_LIST.INSTALLATION_DRIVER, PATH_LIST.INSTALLATION_DRIVER_DETAIL, PATH_LIST.INSTALLATION_DRIVER_CHARGEPOINTS, PATH_LIST.INSTALLATION_BILLING_SETTINGS, PATH_LIST.INSTALLATION_CONTROLLERS, PATH_LIST.INSTALLATION_CONTROLLER_DETAIL, PATH_LIST.INSTALLATION_CONTROLLER_SENSING, PATH_LIST.INSTALLATION_CONTROLLER_TOPOLOGY, PATH_LIST.INSTALLATION_CHARGE_POINTS, PATH_LIST.INSTALLATION_LICENCES],
    "Settings": [PATH_LIST.INSTALLATION_GENERAL_INFO],
    "Chargepoint status": [PATH_LIST.INSTALLATION_CHARGEPOINT_STATUS],
    "Site load": [PATH_LIST.INSTALLATION_SITE_LOAD],
    "Drivers": [PATH_LIST.INSTALLATION_DRIVER, PATH_LIST.INSTALLATION_DRIVER_DETAIL, PATH_LIST.INSTALLATION_DRIVER_CHARGEPOINTS],
    "Invoices": [PATH_LIST.INSTALLATION_INVOICE],
    "Transactions": [PATH_LIST.INSTALLATION_TRANSACTIONS],
    "Billing settings": [PATH_LIST.INSTALLATION_BILLING_SETTINGS],
    "Controllers": [PATH_LIST.INSTALLATION_CONTROLLERS, PATH_LIST.INSTALLATION_CONTROLLER_DETAIL, PATH_LIST.INSTALLATION_CONTROLLER_SENSING, PATH_LIST.INSTALLATION_CONTROLLER_TOPOLOGY],
    "Chargepoints": [PATH_LIST.INSTALLATION_CHARGE_POINTS],
    "Licences": [PATH_LIST.INSTALLATION_LICENCES],
    "Project Management": [PATH_LIST.INSTALLATION_PROJECT_MANAGEMENT]
};

function MenuIconAvatar({ icon }) {
    useEffect(() => {
        const img = new Image();
        img.src = icon;
    }, [icon]);

    return (
        <Avatar
            variant="square"
            src={icon}
            sx={{
                width: 20,
                height: 20,
                bgcolor: "transparent",
                fill: "white"
            }}
        />
    );
}

const SYSTEM_SETTING_MENU = {
    name: "System Settings",
    icon: <MenuIconAvatar icon={SystemSettingIcon} />,
    whiteIcon: <MenuIconAvatar icon={SystemSettingWhiteIcon} />,
    id: "System Settings",
    child: [
        {
            id: "Territories",
            name: "Territories",
            icon: <MenuIconAvatar icon={TerritoriesIcon} />,
            whiteIcon: <MenuIconAvatar icon={TerritoriesWhiteIcon} />,
            path: PATH_LIST.SYSTEM_SETTING_TERRITORIES
        },
        {
            id: "Statutory holidays",
            name: "Statutory holidays",
            icon: <MenuIconAvatar icon={StatutoryHolidaysIcon} />,
            whiteIcon: <MenuIconAvatar icon={StatutoryHolidaysWhiteIcon} />,
            path: PATH_LIST.SYSTEM_SETTING_HOLIDAY
        },
        {
            id: "Time-of-use plans",
            name: "Time-of-use plans",
            icon: <MenuIconAvatar icon={TimeOfUsePlansIcon} />,
            whiteIcon: <MenuIconAvatar icon={TimeOfUsePlansWhiteIcon} />,
            path: PATH_LIST.SYSTEM_SETTING_TIME_OF_USE_PLANS
        },
        {
            id: "Sales tax plans",
            name: "Sales tax plans",
            icon: <MenuIconAvatar icon={SaleTaxPlansIcon} />,
            whiteIcon: <MenuIconAvatar icon={SalesTaxPlanWhiteIcon} />,
            path: PATH_LIST.SYSTEM_SETTING_SALES_TAB_PLANS
        }
    ],
};

// Base menu items shared across most company types
const baseMenuItems = [
    {
        name: "About",
        id: "about",
        icon: <MenuIconAvatar icon={AboutIcon} />,
        path: PATH_LIST.ABOUT_COMPANIES,
        whiteIcon: <MenuIconAvatar icon={AboutWhiteIcon} />
    },
    {
        name: "Team members",
        id: "Team members",
        icon: <MenuIconAvatar icon={TeamMembersIcon} />,
        whiteIcon: <MenuIconAvatar icon={TeamMemberWhiteIcon} />,
        path: PATH_LIST.TEAM_MEMBERS
    },
    {
        name: "Alerts",
        id: "alerts",
        icon: <MenuIconAvatar icon={AlertsIcon} />,
        whiteIcon: <MenuIconAvatar icon={AlertsWhiteIcon} />,
        path: PATH_LIST.ALERTS,
        haveBadge: false
    },
    {
        name: "Activity log",
        id: "Activity log",
        icon: <MenuIconAvatar icon={ActivityLogIcon} />,
        whiteIcon: <MenuIconAvatar icon={ActivityLogWhiteIcon} />,
        path: PATH_LIST.ACTIVITY_LOG
    },
    {
        name: "Search",
        id: "Search",
        icon: <SearchIcon sx={{ width: 20, height: 20 }} />,
        whiteIcon: <SearchIcon sx={{ width: 20, height: 20, color: 'white' }} />,
        path: PATH_LIST.SEARCH
    }
];

const managedCompaniesItem = {
    name: "Managed companies",
    id: "managed companies",
    icon: <MenuIconAvatar icon={ManageCompanyIcon} />,
    whiteIcon: <MenuIconAvatar icon={ManagedCompanyWhiteIcon} />,
    path: PATH_LIST.MANAGED_COMPANIES
};

// Build menu with managed companies in correct position
function buildMenuWithManagedCompanies(items) {
    const [about, ...rest] = items;
    return [about, managedCompaniesItem, ...rest];
}

export const allMenuList = {
    // Variablegrid
    "V": buildMenuWithManagedCompanies(baseMenuItems),
    // Customer (no managed companies)
    "R": baseMenuItems,
    // Contractor
    "C": buildMenuWithManagedCompanies(baseMenuItems),
    // Group
    "G": buildMenuWithManagedCompanies(baseMenuItems),
    // Dealer
    "D": buildMenuWithManagedCompanies(baseMenuItems),
    // Supervisor
    "S": buildMenuWithManagedCompanies(baseMenuItems),
};

export const InstallationMenuList = {
    name: "Installation",
    icon: <MenuIconAvatar icon={InstallationIcon} />,
    whiteIcon: <MenuIconAvatar icon={InstallationWhiteIcon} />,
    id: "Installation",
    child: [
        {
            id: "Settings",
            name: "Settings",
            icon: <MenuIconAvatar icon={SystemSettingIcon} />,
            whiteIcon: <MenuIconAvatar icon={SystemSettingWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_GENERAL_INFO
        },
        {
            id: "Drivers",
            name: "Drivers",
            icon: <MenuIconAvatar icon={DriversIcon} />,
            whiteIcon: <MenuIconAvatar icon={DriversWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_DRIVER
        },
        {
            id: "Invoices",
            name: "Invoices",
            icon: <MenuIconAvatar icon={InvoiceIcon} />,
            whiteIcon: <MenuIconAvatar icon={InvoiceWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_INVOICE
        },
        {
            id: "Transactions",
            name: "Transactions",
            icon: <MenuIconAvatar icon={TransactionIcon} />,
            whiteIcon: <MenuIconAvatar icon={TransactionWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_TRANSACTIONS
        },
        {
            id: "Billing settings",
            name: "Billing settings",
            icon: <MenuIconAvatar icon={BillingSettingsIcon} />,
            whiteIcon: <MenuIconAvatar icon={BillingSettingWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_BILLING_SETTINGS
        },
        {
            id: "Controllers",
            name: "Controllers",
            icon: <MenuIconAvatar icon={ControllersIcon} />,
            whiteIcon: <MenuIconAvatar icon={ControllerWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_CONTROLLERS
        },
        {
            id: "Chargepoints",
            name: "Chargepoints",
            icon: <MenuIconAvatar icon={ChargingPointsIcons} />,
            whiteIcon: <MenuIconAvatar icon={ChargepointWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_CHARGE_POINTS
        },
        {
            id: "Chargepoint status",
            name: "Chargepoint status",
            icon: <MenuIconAvatar icon={ChargingStatusIcon} />,
            whiteIcon: <MenuIconAvatar icon={ChargingStatusWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_CHARGEPOINT_STATUS
        },
        {
            id: "Site load",
            name: "Site load",
            icon: <SiteLoadIcon sx={{ width: 20, height: 20 }} />,
            whiteIcon: <SiteLoadIcon sx={{ width: 20, height: 20, color: 'white' }} />,
            path: PATH_LIST.INSTALLATION_SITE_LOAD
        },
        {
            id: "Licences",
            name: "Licences",
            icon: <MenuIconAvatar icon={LicencesIcon} />,
            whiteIcon: <MenuIconAvatar icon={LicencesWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_LICENCES
        },
        {
            id: "Project Management",
            name: "Project Management",
            icon: <MenuIconAvatar icon={ProjectManagementIcon} />,
            whiteIcon: <MenuIconAvatar icon={ProjectManagementWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_PROJECT_MANAGEMENT
        },
    ],
};

export const InstallationMenuListLimited = {
    name: "Installation",
    icon: <MenuIconAvatar icon={InstallationIcon} />,
    whiteIcon: <MenuIconAvatar icon={InstallationWhiteIcon} />,
    id: "Installation",
    child: [
        {
            id: "Settings",
            name: "Settings",
            icon: <MenuIconAvatar icon={SystemSettingIcon} />,
            whiteIcon: <MenuIconAvatar icon={SystemSettingWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_GENERAL_INFO
        },
        {
            id: "Drivers",
            name: "Drivers",
            icon: <MenuIconAvatar icon={DriversIcon} />,
            whiteIcon: <MenuIconAvatar icon={DriversWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_DRIVER
        },
        {
            id: "Transactions",
            name: "Transactions",
            icon: <MenuIconAvatar icon={TransactionIcon} />,
            whiteIcon: <MenuIconAvatar icon={TransactionWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_TRANSACTIONS
        },
        {
            id: "Chargepoints",
            name: "Chargepoints",
            icon: <MenuIconAvatar icon={ChargingPointsIcons} />,
            whiteIcon: <MenuIconAvatar icon={ChargepointWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_CHARGE_POINTS
        },
        {
            id: "Chargepoint status",
            name: "Chargepoint status",
            icon: <MenuIconAvatar icon={ChargingStatusIcon} />,
            whiteIcon: <MenuIconAvatar icon={ChargingStatusWhiteIcon} />,
            path: PATH_LIST.INSTALLATION_CHARGEPOINT_STATUS
        },
        {
            id: "Site load",
            name: "Site load",
            icon: <SiteLoadIcon sx={{ width: 20, height: 20 }} />,
            whiteIcon: <SiteLoadIcon sx={{ width: 20, height: 20, color: 'white' }} />,
            path: PATH_LIST.INSTALLATION_SITE_LOAD
        },
    ],
};

export const WithoutInstallationMenu = {
    name: "Installation",
    icon: <MenuIconAvatar icon={SystemSettingIcon} />,
    whiteIcon: <MenuIconAvatar icon={SystemSettingWhiteIcon} />,
    id: "Installation",
    path: "/app/installation"
};

export const manageCompanyMenu = managedCompaniesItem;
